import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Follow = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g>
        <g>
          <path
            d="M8.03906 11.7699V8.43652"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.66536 10.1025H6.33203"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.6654 8.10254V12.1025C14.6654 14.7692 13.9987 15.4359 11.332 15.4359H4.66536C1.9987 15.4359 1.33203 14.7692 1.33203 12.1025V5.43587C1.33203 2.76921 1.9987 2.10254 4.66536 2.10254H5.66536C6.66536 2.10254 6.88536 2.39587 7.26536 2.90254L8.26536 4.23587C8.5187 4.56921 8.66536 4.76921 9.33203 4.76921H11.332C13.9987 4.76921 14.6654 5.43587 14.6654 8.10254Z"
            stroke={stroke}
            strokeWidth="1.5"
            strokeMiterlimit="10"
          />
        </g>
      </g>
    </svg>
  );
};

Follow.displayName = 'Follow';
